import { render, staticRenderFns } from "./productpricinglog-add-or-update.vue?vue&type=template&id=71f5512d&"
import script from "./productpricinglog-add-or-update.vue?vue&type=script&lang=js&"
export * from "./productpricinglog-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports